<template>
  <div class="site-info">
    <div class="container" v-html="site_info.site_footer_html"></div>
  </div>
</template>
<script>
import { api, session } from "@/assets/js/util.js";
export default {
  name: "SiteInfo",
  data() {
    return {
      site_info: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      let site_info = session.get("site_info");

      if (!site_info === true) {
        api.get("site_info").then(function(res) {
          if (res.code) {
            session.set("site_info", res.data);
            that.site_info = session.get("site_info");
          }
        });
      } else {
        that.site_info = session.get("site_info");
      }
    },
  },
};
</script>
<style scoped></style>
